import RoutesEditerCeaf from './editer/routes';
import RoutesVisualiserCeaf from './visualiser/routes';
import { initSubRoutes } from '../../../../utils/router';
import { CEAF } from '../../../../constants/accessibilite.constants';

const RoutesCeaf = initSubRoutes({
    route: '/ceaf',
    subroutes: {
        editer: RoutesEditerCeaf,
        visualiser: RoutesVisualiserCeaf,
    },
    nom: `Carte européenne d'arme à feu (${CEAF})`,
});

export default RoutesCeaf;
